import { gql } from '@apollo/client';

/**
 * Successful, non-optimization report runs that an optimization or mix & match
 * can be built on. Runs without a job ID (e.g. archetype projects) cannot be
 * parents because the request references the parent by job ID.
 */
export default gql`
  query ParentReportCandidatesQuery($workspaceID: Int, $orderBy: [ReportJobsOrderBy!]) {
    allReportJobs(
      condition: { workspaceId: $workspaceID, reportStatus: SUCCESS }
      filter: {
        reportType: { distinctFromInsensitive: "optimization" }
        jobId: { isNull: false }
      }
      orderBy: $orderBy
    ) {
      nodes {
        jobId
        startedAt
        reportId
        targetGroupName
        clientName
        projectName
        workspaceId
        passedQa
      }
    }
  }
`;
